module.exports = __webpack_public_path__ + "static/media/btn_snake_active.57672036.png";